export const SOFTLINE_API_PMS_ROSTER_DEPARTMENT_HEADS =
  'roster-service/pms/roster/departmenthead';
export const SOFTLINE_API_PMS_ROSTER_PMS_TASKS =
  'roster-service/pms/roster/tasks/{{employeeId}}';
export const SOFTLINE_API_PMS_ROSTER_ABSENCE = 'roster-service/pms/roster/absence';

export const SOFTLINE_API_PMS_ROSTER_STRUCTURE =
  'roster-service/pms/roster/structure/{{employeeId}}';

export const SOFTLINE_API_PMS_ROSTER_EMPLOYEE_BALANCE =
  'roster-service/pms/roster/structure/row/detail/balance/{{employeeId}}';
export const SOFTLINE_API_PMS_ROSTER_EMPLOYEE_WORKSCHEMA =
  'roster-service/pms/roster/structure/row/detail/workschema/{{employeeId}}';

export const SOFTLINE_API_PMS_ROSTER_EMPLOYEE_CONTENT =
  'roster-service/pms/roster/content/{{employeeId}}';
export const SOFTLINE_API_PMS_ROSTER_EMPLOYEE_CONTENT_DETAIL =
  'roster-service/pms/roster/content/{{employeeId}}/data/{{id}}';
export const SOFTLINE_API_PMS_ROSTER_CONTENT = 'roster-service/pms/roster/content';
export const SOFTLINE_API_PMS_ROSTER_CONTENT_ENTRY =
  'roster-service/pms/roster/content/{{id}}';
export const SOFTLINE_API_PMS_ROSTER_CONTENT_DELETE =
  'roster-service/pms/roster/content/delete';
